export interface Contract {
  id: string;
  title: string;
  type: 'Licencia' | 'NDA' | 'Colaboración' | 'Transferencia';
  status: 'Borrador' | 'En Negociación' | 'Firmado' | 'Vigente' | 'Vencido';
  stakeholderId: string;
  stakeholderName: string;
  projectId: string;
  projectName: string;
  startDate: string;
  endDate: string;
  value: number;
  currency: string;
  description?: string;
}

export const mockContracts: Contract[] = [
  {
    id: 'cont-001',
    title: 'Licencia Exclusiva - Sistema de Diagnóstico IA',
    type: 'Licencia',
    status: 'Vigente',
    stakeholderId: 'stake-001',
    stakeholderName: 'MedTech Innovations S.A.S.',
    projectId: 'proy-001',
    projectName: 'Sistema de Diagnóstico Médico con IA',
    startDate: '2024-06-01T00:00:00Z',
    endDate: '2029-05-31T00:00:00Z',
    value: 500000,
    currency: 'USD',
    description: 'Licencia exclusiva para comercialización en territorio colombiano con regalías del 8% sobre ventas netas.'
  },
  {
    id: 'cont-002',
    title: 'Acuerdo de Confidencialidad - Blockchain Agrícola',
    type: 'NDA',
    status: 'Firmado',
    stakeholderId: 'stake-002',
    stakeholderName: 'AgroTech Solutions',
    projectId: 'proy-002',
    projectName: 'Plataforma de Blockchain para Trazabilidad Agrícola',
    startDate: '2024-09-01T00:00:00Z',
    endDate: '2025-09-01T00:00:00Z',
    value: 0,
    currency: 'USD',
    description: 'Acuerdo de confidencialidad bilateral para evaluación de tecnología blockchain.'
  },
  {
    id: 'cont-003',
    title: 'Contrato de Licenciamiento - Algoritmo Energético',
    type: 'Licencia',
    status: 'Vigente',
    stakeholderId: 'stake-003',
    stakeholderName: 'Green Energy Capital',
    projectId: 'proy-003',
    projectName: 'Algoritmo de Optimización Energética',
    startDate: '2024-03-15T00:00:00Z',
    endDate: '2027-03-14T00:00:00Z',
    value: 350000,
    currency: 'USD',
    description: 'Licencia no exclusiva con opción de exclusividad tras primer año. Regalías del 6%.'
  },
  {
    id: 'cont-004',
    title: 'Acuerdo de Colaboración - Biosensor',
    type: 'Colaboración',
    status: 'En Negociación',
    stakeholderId: 'stake-004',
    stakeholderName: 'Dr. Juan Pérez',
    projectId: 'proy-004',
    projectName: 'Biosensor para Detección de Contaminantes',
    startDate: '2025-01-01T00:00:00Z',
    endDate: '2026-12-31T00:00:00Z',
    value: 120000,
    currency: 'USD',
    description: 'Acuerdo de colaboración para desarrollo conjunto de nuevas aplicaciones del biosensor.'
  },
  {
    id: 'cont-005',
    title: 'Licencia de Software - Plataforma EduAR',
    type: 'Licencia',
    status: 'Borrador',
    stakeholderId: 'stake-005',
    stakeholderName: 'EduTech Ventures',
    projectId: 'proy-005',
    projectName: 'Software de Realidad Aumentada para Educación',
    startDate: '2025-02-01T00:00:00Z',
    endDate: '2028-01-31T00:00:00Z',
    value: 200000,
    currency: 'USD',
    description: 'Licencia de software educativo con modelo de suscripción anual.'
  },
  {
    id: 'cont-006',
    title: 'Transferencia Tecnológica - Material EcoBuild',
    type: 'Transferencia',
    status: 'Vigente',
    stakeholderId: 'stake-006',
    stakeholderName: 'Construcciones Sostenibles Ltda.',
    projectId: 'proy-006',
    projectName: 'Material Compuesto para Construcción Sostenible',
    startDate: '2024-07-01T00:00:00Z',
    endDate: '2029-06-30T00:00:00Z',
    value: 750000,
    currency: 'USD',
    description: 'Transferencia completa de tecnología incluyendo know-how y asistencia técnica por 2 años.'
  },
  {
    id: 'cont-007',
    title: 'NDA - Evaluación Tecnología IA',
    type: 'NDA',
    status: 'Vencido',
    stakeholderId: 'stake-001',
    stakeholderName: 'MedTech Innovations S.A.S.',
    projectId: 'proy-001',
    projectName: 'Sistema de Diagnóstico Médico con IA',
    startDate: '2023-01-15T00:00:00Z',
    endDate: '2024-01-15T00:00:00Z',
    value: 0,
    currency: 'USD',
    description: 'Acuerdo de confidencialidad inicial para evaluación de tecnología (ya vencido).'
  }
];
